import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { OperatorCompaniesApi } from '../api/operator-companies.api';
import { OperatorCompany } from '../state/operator-companies/operator-companies-state.model';

@Injectable({ providedIn: 'root' })
export class OperatorCompaniesService {
  private readonly _api = inject(OperatorCompaniesApi);

  public getCompanies(): Observable<OperatorCompany[]> {
    return this._api.getCompanies();
  }
}
